module.exports = __webpack_public_path__ + "assets/message.c145760b.svg";